/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SectorEnum = 1 | 2;

export const SectorEnum = {

    NUMBER_1: 1 as SectorEnum,

    NUMBER_2: 2 as SectorEnum
};

